module.exports = __webpack_public_path__ + "static/media/page-next.eb4ff121.svg";